'use client';

import {
  FeatureItem,
  FileTypeConfig,
  LandingFeatures,
  LandingHero,
  LandingUseCases,
} from '../_components';
import {
  Calculator,
  Columns,
  FileText,
  ImageIcon,
  TableIcon,
} from 'lucide-react';

const pdfConfig: FileTypeConfig = {
  type: 'pdf',
  title: '在线翻译 PDF 文档·完美保留原始版式',
  subtitle: '复杂排版、学术论文、技术文档的首选解决方案',
  description: '支持图文混排、表格、数学公式的完美还原',
  icon: <FileText className="w-full h-full" />,
  gradientFrom: '#f43f5e', // Rose 500
  gradientTo: '#e11d48', // Rose 600
  accentColor: 'rose',
  particleColors: ['#f43f5e', '#fb7185', '#fda4af'],
  accept: {
    'application/pdf': ['.pdf'],
  },
  stats: {
    users: '100万+',
    accuracy: '99.2%',
    files: '500万+',
  },
};

const pdfFeatures: FeatureItem[] = [
  {
    icon: Calculator,
    title: '公式优化技术',
    description: 'LaTeX/MathML 公式精准转换，数学公式完美保留',
  },
  {
    icon: Columns,
    title: '多栏排版保留',
    description: '学术期刊双栏、三栏排版精准识别还原',
  },
  {
    icon: ImageIcon,
    title: '图文混排识别',
    description: '智能识别图片与文字区域，保持原始效果',
  },
  {
    icon: TableIcon,
    title: '表格结构保持',
    description: '复杂表格完整保留，边框样式不丢失',
  },
];

const pdfUseCases = [
  '科研论文',
  '技术手册',
  '法律合同',
  '产品说明书',
  '财务报表',
  '学术著作',
];

const PdfPage = () => {
  return (
    <div className="w-full">
      <LandingHero config={pdfConfig} />
      <LandingFeatures
        title="PDF 专属优势"
        features={pdfFeatures}
        gradientFrom={pdfConfig.gradientFrom}
        gradientTo={pdfConfig.gradientTo}
      />
      <LandingUseCases
        useCases={pdfUseCases}
        gradientFrom={pdfConfig.gradientFrom}
        gradientTo={pdfConfig.gradientTo}
      />
    </div>
  );
};

export default PdfPage;
